import {Color, ScaleType} from "@swimlane/ngx-charts";

export class NgxChartSingleSeries {
  /*
* @desc
* Typically used by the Bar Charts, Number Cards and Pie Charts
* */
  name: string;
  value: number;
}

export class NgxChartMultiSeries {
  /*
  * @desc
  * Typically used by the Advanced Pie Charts and Stacked Bar charts
  * */
  name: string;
  series: NgxChartSingleSeries[];
}

// FixMe jC rel-1.3: define these schemes as Color

export const vividColorScheme = {domain: ['#647c8a', '#3f51b5', '#2196f3', '#00b862', '#afdf0a', '#a7b61a', '#f3e562', '#ff9800', '#ff5722', '#ff4514']};
export const naturalColorScheme = {domain: ['#bf9d76', '#e99450', '#d89f59', '#f2dfa7', '#a5d7c6', '#7794b1', '#afafaf', '#707160', '#ba9383', '#d9d5c3']};
export const coolColorScheme = {domain: ['#a8385d', '#7aa3e5', '#a27ea8', '#aae3f5', '#adcded', '#a95963', '#8796c0', '#7ed3ed', '#50abcc', '#ad6886']};
export const aquaColorScheme = {domain: ['#e0f7fa', '#b2ebf2', '#80deea', '#4dd0e1', '#26c6da', '#00bcd4', '#00acc1', '#0097a7', '#00838f', '#006064']};
export const neonColorScheme = {domain: ['#FF3333', '#FF33FF', '#CC33FF', '#0000FF', '#33CCFF', '#33FFFF', '#33FF66', '#CCFF33', '#FFCC00', '#FF6600']};
export const TsAdminColorScheme = {domain: ['#A10A28', '#EF6D49', '#a6cb0b', '#000080', '#333']};
export const PayeeColorScheme = {domain: ['#A10A28', '#EF6D49', '#a6cb0b', '#000080']};
export const numberCardColorScheme = {domain: ['#FFFFFF', '#FFFFFF', '#FFFFFF']};
export const ExpenseReportColorScheme = {domain: ['#A10A28', '#EF6D49', '#a6cb0b']};
export const MyDashboardColorScheme = {domain: ['#000080', '#2FCBE3', '#cccccc', '#A6cb0b', '#BDB76D', '#a8385d', '#6C9208', '#a27ea8', '#aae3f5', '#adcded', '#a95963', '#8796c0', '#7ed3ed', '#50abcc', '#ad6886']};

export const ProjectTaskAllocationScheme: Color = {name: "projectTaskAllocationColor", selectable: false, group: ScaleType.Time, domain: ['#A10A28', '#EF6D49', '#a6cb0b', '#707160']};
export const PayrollRegisterScheme = {domain: ['#A10A28', '#EF6D49', '#a6cb0b', '#707160']};
export const numberCardColor: string = '#FFFFFF';

export const ngxBarChartView = ['650', '400'];
export const ngxNumberCardView: any[] = ['650', '210'];
export const ngxNumberCardViewTriple: any[] = ['700', '210'];
